module.exports = __webpack_public_path__ + "img/ic_64_feature_battle.ec417a36.svg";